import * as React from "react";
import PropTypes from "prop-types";
import { Button } from "./button";
import { cn } from "../../utils/utils";
import { ArrowRightIcon } from "@radix-ui/react-icons";

const BentoGrid = ({ children, className }) => {
  return (
    <div
      className={cn(
        "grid w-full auto-rows-[22rem] grid-cols-3 gap-4",
        className
      )}
    >
      {children}
    </div>
  );
};

BentoGrid.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

const BentoCard = ({
  name,
  className,
  background,
  Icon,
  description,
  href,
  cta,
}) => (
  <div
    role="article"
    aria-labelledby={`card-title-${name}`}
    className={cn(
      "group relative col-span-3 flex flex-col justify-between overflow-hidden rounded-xl",
      "bg-white [box-shadow:0_0_0_1px_rgba(0,0,0,.03),0_2px_4px_rgba(0,0,0,.05),0_12px_24px_rgba(0,0,0,.05)]",
      "transform-gpu  ",
      className
    )}
  >
    <div aria-hidden="true">{background}</div>
    <div className="z-10 flex transform-gpu flex-col gap-1 p-6 transition-all duration-300 group-hover:-translate-y-10">
      <Icon
        className="h-12 w-12 origin-left transform-gpu text-primary transition-all duration-300 ease-in-out group-hover:scale-75"
        aria-hidden="true"
      />
      <h3
        id={`card-title-${name}`}
        className="text-xl font-semibold text-neutral-700 "
      >
        {name}
      </h3>
      <p className="max-w-lg text-neutral-400">{description}</p>
    </div>

    <div
      className={cn(
        "absolute bottom-0 flex w-full translate-y-10 transform-gpu flex-row items-center p-4 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100"
      )}
    >
      <Button variant="ghost" asChild size="sm" className="pointer-events-auto">
        <a href={href} aria-label={`${cta} about ${name}`}>
          {`Explore ${name}`}
          <ArrowRightIcon className="ml-2 h-4 w-4" aria-hidden="true" />
        </a>
      </Button>
    </div>
    <div
  className="absolute inset-0 transform-gpu transition-all duration-300 group-hover:bg-black/[.03] pointer-events-none"

      aria-hidden="true"
    />
  </div>
);

BentoCard.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  background: PropTypes.node.isRequired,
  Icon: PropTypes.elementType.isRequired,
  description: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  cta: PropTypes.string.isRequired,
};

export { BentoCard, BentoGrid };
